import { createAction } from '@reduxjs/toolkit';

export const podcastUpdateId = createAction('podcast/updateId');
export const podcastUpdateUID = createAction('podcast/updateUid');
export const podcastUpdateSID = createAction('podcast/updateSid');
export const podcastUpdateIsAdded = createAction('podcast/updateIsAdded');
export const podcastUpdateIsActive = createAction('podcast/updateIsActive');

export const podcastStore = createAction('podcast/store');
export const podcastClear = createAction('podcast/clear');

export const podcastUpdateRequest = createAction('podcast/updateRequest');
export const podcastUpdateIsLoading = createAction('podcast/updateIsLoading');
export const podcastUpdateError = createAction('podcast/updateError');
export const podcastUpdateStore = createAction('podcast/updateStore');

export const podcastUpdateItems = createAction('podcast/updateItems');
export const podcastUpdateHeading = createAction('podcast/updateHeading');
export const podcastUpdateBlockContent = createAction('podcast/updateBlockContent');
export const podcastUpdateBlockDesign = createAction('podcast/updateBlockDesign');
export const podcastUpdateAlbums = createAction('podcast/updateAlbums');
